import Fetch from "utils/fetch";

/*******************************************************************************
 *
 *   1. Default State
 *   2. Action Types
 *   3. ACtion Creators
 *   4. Reducers
 *
 */

/*******************************************************************************
 *  1. Default State
 */

const enrollState = {
    congrads :'',
    nomail :'',
    resend:'',
    status:'',
    repAgencyList:'',
    businessNameList:'',
	formStatus:'',
	statusMessage:'',
	paxEmailAddress: '',
	paxId: ''
};

/*******************************************************************************
 *  2. Action Types
 */

const FETCH_ENROLLMENT = "fetchEnrollment";
const FETCHED_ENROLLMENT = "fetchedEnrollment";

const FETCH_BUSINESS_JSON = "fetchBusinessDetails";
const FETCHED_BUSINESS_JSON = "fetchedBusinessDetails";

const SEND_ENROLL_DETAILS = "sendEnrollDetails";
const UPDATE_ENROLL_DETAILS = "updateEnrollDetails";

const RENSEND_EMAIL_DETAILS = "sendEmailDetails";
const UPDATE_EMAIL_DETAILS = "updateEmailDetails";

const CLEAR_ENROLL = "clearEnrollDetails";

/*******************************************************************************
 *  3. Action Creators
 */

export const clearEnroll = () => {
	return dispatch => {
		dispatch({
		type: CLEAR_ENROLL
		});
	}
};

export const fetchBusinessDetails = (data) => {
    return dispatch => {
		return Fetch({
			url: FEEDS.APP_FETCH_BRAND,
			method: 'POST',
			dispatch: dispatch,
			type: FETCH_BUSINESS_JSON,
			body: data
		}).then(results => {
			dispatch({
				type: FETCHED_BUSINESS_JSON,
				data: results.data
			});
			dispatch(results.fetched);
		});
    };
};

export const fetchEnrollment = (data) => {
	console.log("here",data);
	return dispatch => {
		return Fetch({
			url: FEEDS.APP_ENROLLMENT,
			dispatch: dispatch,
			type: FETCH_ENROLLMENT,
			body: {
				paxId: data
			}
		}).then(results => {
			dispatch({
				type: FETCHED_ENROLLMENT,
				data: results.data
			});
			dispatch(results.fetched);
		});
	};
};

export const sendEnrollDetails = data => {
	return dispatch => {
		return Fetch({
			url: FEEDS.APP_ENROLL_SUCCESS,
			method: "POST",
			dispatch: dispatch,
			type: SEND_ENROLL_DETAILS,
			body: data
		}).then(results => {
			dispatch({
				type: UPDATE_ENROLL_DETAILS,
				data: results.data
			});
			dispatch(results.fetched);
		});
	};
};

export const sendEmailDetails = (data) => {
	return dispatch => {
		return Fetch({
			url: FEEDS.APP_RESEND_EMAIL_API,
			method: "POST",
			dispatch: dispatch,
			type: RENSEND_EMAIL_DETAILS,
			body: data
		}).then(results => {
			dispatch({
				type: UPDATE_EMAIL_DETAILS,
				data: results.data
			});
			dispatch(results.fetched);
		});
	};
};

/*******************************************************************************
 *  4. Reducers
 */

export default (state = enrollState, action) => {
  switch (action.type) {
    case FETCHED_ENROLLMENT:
      return {
        ...state,
        ...action.data
      };

    case UPDATE_ENROLL_DETAILS:
      return {
        ...state,
        ...action.data,
        congrads: action.data,
        nomail: action.data,
        resend: action.data,
        status: action.data.code,
        enrollErrorMessage: action.data.message,
		paxEmailAddress: action.data.paxEmailAddress,
		paxId: action.data.paxId
      // 
    };
 
      case FETCHED_BUSINESS_JSON:
      return {
        ...state,
        ...action.data,
        repAgencyList:action.data.repAgnList,
        businessNameList:action.data.busList        

      };
	  
	  case UPDATE_EMAIL_DETAILS:
      return {
        ...state,
        ...action.data,
		formStatus: action.data.code,
		statusMessage: action.data.message
      };

      case CLEAR_ENROLL:
      return {
        congrads: "",
        nomail: "",
        resend: "",
        status:""
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/enroll/enroll-dux.js